import { callApi } from '../../api/call';
import { emailSettingsService } from '../../sendgrid/settings/email/services/emailSettingsService';

export const TEST_EMAIL_TEMPLATES = [
  { key: 'bookingConfirmation', label: 'Booking confirmation' },
  { key: 'appointmentReminder', label: 'Appointment reminder' },
  { key: 'scheduleChange', label: 'Schedule change' },
  { key: 'depositConfirmation', label: 'Deposit confirmation' },
  { key: 'balanceConfirmation', label: 'Balance confirmation' },
  { key: 'checkInLinkRequest', label: 'Check-in link' },
];

export async function sendSendGridConnectionTest(to) {
  const res = await callApi('/api/sendgrid/health', { to });
  if (!res?.data?.success) {
    throw new Error(res?.data?.message || 'SendGrid connection test failed');
  }
  return res.data;
}

export async function sendCompanyTestEmail(companyId, templateType, testEmail) {
  return emailSettingsService.sendTestEmail(companyId, templateType, testEmail);
}
